export const models = [
  {
    name: "wc1",
    sceneName: "scene2-hotspot1",
    position: { x: 0, y: 0, z: 0 },
    rotation: { x: 0, y: 180, z: 90 },
    mtl: "../images/3d/wc1/model.mtl",
    src: "../images/3d/wc1/model.obj",
    texPath: "../images/3d/wc1/",
    title: "Wall Clock",
    description:
      "Sed ultrices ipsum vitae tellus pharetra,nec aliquet neque aliquam. Curabitur eu laoreet elit.Sed blandit gravida sapien ultrices dignissim. Nunc sodales ullamcorper magna, nec bibendum enim ullamcorper sed.",
  },
  {
    name: "ww1",
    sceneName: "scene2-hotspot2",
    position: { x: 0, y: 0, z: 0 },
    rotation: { x: 0, y: 0, z: 175 },
    mtl: "../images/3d/ww1/model.mtl",
    src: "../images/3d/ww1/model.obj",
    texPath: "../images/3d/ww1/",
    title: "Wrist Watch",
    description:
      "In vitae velit auctor, faucibus velit sed, pulvinar justo. Phasellus fermentum faucibus ligula, sit amet pharetra ante ornare sit amet. Phasellus eu tellus non est rutrum fringilla. Etiam viverra turpis ac consectetur iaculis.",
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/model.js
// module id = 251
// module chunks = 0